import { render, staticRenderFns } from "./ShowProductsPage.vue?vue&type=template&id=5b307394&scoped=true&"
import script from "./ShowProductsPage.vue?vue&type=script&lang=js&"
export * from "./ShowProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowProductsPage.vue?vue&type=style&index=0&id=5b307394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b307394",
  null
  
)

export default component.exports